<template>
<div class="full-wrapper">
  <el-scrollbar :ref="scrollbarRef">
    <div class="full">
      <w-tool-tabs class="tab-button" size="mini" v-model="activeTab">
        <el-tab-pane label="이벤트 현황" name="event-status">
          <w-event-status ref="eventStatusRef" :active="actveEventStatus" />
        </el-tab-pane>
        <el-tab-pane ref="eventHistTab" label="이벤트 이력" name="event-hist">
          <w-event-hist ref="eventHistRef" :active="actveEventHist" />
        </el-tab-pane>
        <el-row slot="tool" type="flex" justify="space-between">
          <w-smart-analyzer-button :activeTab="activeTab" class="mr-r4"></w-smart-analyzer-button>
          <w-event-ticket-add-button :active-tab="activeTab" @load-data="loadData"></w-event-ticket-add-button>
        </el-row>
      </w-tool-tabs>
    </div>
  </el-scrollbar>
  <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop" />
</div>
</template>

<script>
import ScrollbarMixin from '@/mixins/scrollbar';
import WEventStatus from '@/views/event/event-status';
import WEventHist from '@/views/event/event-hist';
import WSmartAnalyzerButton from '@/views/event/components/SmartAnalyzerButton';
import WEventTicketAddButton from '@/views/event/components/EventTicketAddButton';

export default {
  name: 'WPerformanceNodeEvent',
  mixins: [ScrollbarMixin],
  components: {
    WEventStatus,
    WEventHist,
    WSmartAnalyzerButton,
    WEventTicketAddButton,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      activeTab: 'event-status',
    };
  },
  computed: {
    actveEventStatus() {
      return this.active && this.activeTab === 'event-status';
    },
    actveEventHist() {
      return this.active && this.activeTab === 'event-hist';
    },
  },
  watch: {
    activeTab: {
      handler() {
        const emptyArr = [];
        this.$store.dispatch('setSelectedEvents', emptyArr);
      },
      immediate: true,
    },
  },
  mounted() {
    this.setScrollData();
    // TODO: #48402 IE 이슈 해결을 위해 추가. 추후 더 좋은 대응 방법이 있을 경우 대체 필요
    this.$nextTick(() => {
      const eventHistEl = this.$refs.eventHistTab.$el;
      if (eventHistEl.style.cssText.indexOf('display: block !important;') >= 0) {
        eventHistEl.style.cssText = eventHistEl.style.cssText.replace('display: block !important;', 'display: none;');
      }
    });
  },
  methods: {
    loadData() {
      if (this.activeTab === 'event-status') {
        this.$refs.eventStatusRef.loadData();
      } else {
        this.$refs.eventHistRef.loadData();
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/event/index.vue